// document.addEventListener("DOMContentLoaded", function() {
//   const header = document.querySelector('.header-wrapper');

//   window.addEventListener('scroll', function() {
//     if (window.scrollY > 20) {
//       header.classList.add('scrolled');
//     } else {
//       header.classList.remove('scrolled');
//     }
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector('.header-wrapper');

  window.addEventListener('scroll', function () {
    if (window.scrollY > 20) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });
});

















document.addEventListener("DOMContentLoaded", function() {

  // INIT SWIPER
  var swiper = new Swiper(".videoSwiper", {
    slidesPerView: 4,
    dots:true,
    spaceBetween: 20,

      pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      769: { slidesPerView: 4 },
      480: {
        slidesPerView: 1,
        spaceBetween: 10,
        observer: true,
        observeParents: true,

      }
    }
  });

  // VIDEO PLAY / PAUSE LOGIC
  document.querySelectorAll(".video-container").forEach(function(container) {
    
    let video = container.querySelector(".video-player");
    let button = container.querySelector(".play-btn");

    // Play button click
    button.addEventListener("click", function() {
      video.play();
      button.classList.add("hide");
    });

    // Click on video toggles play/pause
    video.addEventListener("click", function() {
      if (video.paused) {
        video.play();
        button.classList.add("hide");
      } else {
        video.pause();
        button.classList.remove("hide");
      }
    });

    // Pause event
    video.addEventListener("pause", function() {
      button.classList.remove("hide");
    });

  });

});

